// Abertura do app e do painel (a logo que se desenha). Ela vem pronta no HTML: o __root desenha em /app e /admin, para
// a tela não ficar branca enquanto o JavaScript carrega, e o mesmo elemento segue na hidratação (a animação não
// recomeça). O layout de cada um fecha quando a sessão e os dados chegam.

let fechada = false;
const ouvintes = new Set<() => void>();

export function aberturaFechada(): boolean {
  return fechada;
}

export function aoMudarAbertura(ouvinte: () => void): () => void {
  ouvintes.add(ouvinte);
  return () => {
    ouvintes.delete(ouvinte);
  };
}

export function fecharAbertura(): void {
  if (fechada) return;
  fechada = true;
  ouvintes.forEach((o) => o());
}

/**
 * Quanto falta para a logo terminar de se desenhar (uns 2,3 s; com movimento reduzido, 0,25 s), contando do começo da
 * página: o tempo em que o JavaScript carregava já conta.
 */
export function tempoQueFaltaDaAbertura(): number {
  const total = window.matchMedia?.("(prefers-reduced-motion: reduce)").matches ? 250 : 2300;
  return Math.max(0, total - performance.now());
}
